import api from "./api";
import auth from "./auth";

const getBrands = () => {
    return new Promise((resolve, reject) => {
        api.get("organization-service/brand/list", auth.getHeader())
            .then(response => resolve(response))
            .catch(e => reject(e.errors));
    });
};

const getVisibleBrands = () => {
    return new Promise((resolve, reject) => {
        api.get("organization-service/brand/list/visible", auth.getHeader())
            .then(response => resolve(response))
            .catch(e => reject(e.errors));
    });
};

const create = payload => {
    return new Promise((resolve, reject) => {
        api.post("organization-service/brand/create", payload, auth.getHeader())
            .then(response => resolve(response))
            .catch(e => reject(e.errors));
    });
};

const update = (id, payload) => {
    return new Promise((resolve, reject) => {
        api.post(
            "organization-service/brand/update/" + id,
            payload,
            auth.getHeader()
        )
            .then(response => resolve(response))
            .catch(e => reject(e.errors));
    });
};

const view = id => {
    return new Promise((resolve, reject) => {
        api.get("organization-service/brand/view/" + id, auth.getHeader())
            .then(response => resolve(response))
            .catch(e => reject(e.errors));
    });
};

const doDelete = id => {
    return new Promise((resolve, reject) => {
        api.delete("organization-service/brand/delete/" + id, auth.getHeader())
            .then(response => resolve(response))
            .catch(e => reject(e.errors));
    });
};

export default {
    getBrands,
    getVisibleBrands,
    create,
    update,
    view,
    delete: doDelete
};
